import { createRouter, createWebHistory, RouteRecordRaw } from "vue-router";
import NotFound from "@/views/NotFound.vue";
import { iziRouter } from "./izi";
import AuthService from "@/services/auth.service";
const routes: Array<RouteRecordRaw> = [
  {
    path: "/login",
    name: "login",
    component: () =>
      import(/* webpackChunkName: "login" */ "../views/Login/Login.vue"),
    beforeEnter: (to, from, next) => {
      AuthService.getCurrentAuth().subscribe(result => {
        if (result) {
          next("/");
        } else {
          next(true);
        }
      });
    }
  },
  {
    path: "/register",
    name: "register",
    component: () =>
      import(/* webpackChunkName: "register" */ "../views/Register.vue")
  },
  ...iziRouter,
  { path: "/:pathMatch(.*)*", name: "not-found", component: NotFound }
];

const router = createRouter({
  history: createWebHistory(process.env.BASE_URL),
  routes
});

export default router;
